export default "__VITE_ASSET__DYTGeRPP__"